import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom"
import RouteInventario from "./pages/inventario/RouteInventario"
import Dashboard from "./pages/dashboard/Dashboard"
import Ficha from "./pages/ficha/Ficha"
import Inventario from "./pages/inventario/Inventario"
import CatalogoSap from "./pages/catalogosap/CatalogoSap"
import Almacen from "./pages/almacen/Almacen"
import LoginForm from "./pages/login/LoginForm"
import Protected from "./Protected"
import Welcome from "./pages/login/Welcome"
import NotFound from "./NotFound"
import ScrollToTopButton from "./ScrollButtons/ScrollButtons"
import ChatboxIA from "./pages/chatboxIA/ChatboxIA"

const App = () => {
  return (
    <div className="wrapper">
      <Router basename=''>
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="/welcome" element={<Protected Component={Welcome} />} />
          <Route path="/dashboard" element={<Protected Component={Dashboard} />} />
          <Route path="/inventario" element={<RouteInventario />}>
            <Route path="" element={<Protected Component={Inventario} />} />
            <Route path=":codigo" element={<Protected Component={Ficha} />} />
          </Route>
          <Route path="/catalogosap" element={<Protected Component={CatalogoSap} />} />
          <Route path="/almacen" element={<Protected Component={Almacen} />} />
          <Route path="/chatbox-ia" element={<Protected Component={ChatboxIA} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <ScrollToTopButton />      
    </div>
  )
}
export default App